import { Link } from './Link';

export const Footer = () => {
  return (
    <footer className="bg-[#0D0A00] w-full">
      <div className="flex flex-col items-center px-6 sm:px-10 md:px-16 pt-16 pb-10">
        <div className="w-full max-w-7xl">
          {/* Newsletter */}
          <div className="flex flex-col md:flex-row justify-between items-start gap-8 w-full mb-12">
            <div className="w-full md:w-[480px]">
              <span className="eyebrow text-white/55 mb-5">Nieuwsbrief</span>
              <h3 className="mt-5 text-white text-[26px] md:text-[32px] font-medium tracking-[-0.025em] leading-[1.1] mb-3">
                Blijf op de hoogte —{' '}
                <span className="font-serif-display italic font-normal text-white/60">elk kwartaal.</span>
              </h3>
              <p className="text-white/50 text-[15px] leading-[1.65] max-w-[44ch]">
                Eén keer in de drie maanden versturen we een nieuwsbrief. Hierin delen we veranderingen, updates en getuigenissen.
              </p>
            </div>
            <div className="flex flex-col gap-2 md:items-end">
              <a
                href="https://gmail.us14.list-manage.com/subscribe?u=408511325a3ff7fdfa487ac56&id=f5769fe273"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-pill"
                style={{ background: '#F5B800', color: '#0D0A00' }}
              >
                Meld aan
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 10L10 2M10 2H4M10 2V8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
              <span className="text-[11px] text-white/30">
                Door aan te melden accepteer je onze{' '}
                <a href="/algemenevoorwaarden" className="underline text-white/40 hover:text-white/60 transition-colors">
                  Privacy Policy
                </a>
              </span>
            </div>
          </div>

          {/* Divider */}
          <div className="w-full h-px bg-white/10 mb-8"></div>

          {/* Bottom */}
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <span className="text-white/30 text-[13px]">
              <a
                href="https://www.instagram.com/casperoudman/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white/70 transition-colors"
              >
                CASPER OUDMAN
              </a>
              {' '}— ©2026 — All rights reserved
            </span>
            <div className="flex flex-wrap gap-6 justify-center">
              <Link href="/over-ons" className="text-white/40 text-[13px] hover:text-white/70 transition-colors">Over ons</Link>
              <Link href="/algemenevoorwaarden" className="text-white/40 text-[13px] hover:text-white/70 transition-colors">Voorwaarden</Link>
              <Link href="/draagbij" className="text-white/40 text-[13px] hover:text-white/70 transition-colors">Draag bij</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
